//INIT 

console.log('init.js ->');

var init = function(){ console.log('init() ->');

};init();

//INIT END